/*
 *******************************************************************************
 * 
 *  Filename:   ./reducers/reducerBlockFormatLevels.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Reducers for Block Format Levels
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Wednesday, November 14, 2018 - 01:04:57 AM (CST)
 *  
 *  Notes:
 *
 *  
 *  Revisions:
 *      11/14/2018  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2018 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

import {
    BLOCKFORMATLEVEL_LIST_CONTAINER_LOADED,
    BLOCKFORMATLEVEL_LIST_CONTAINER_UNLOADED,
    BLOCKFORMATLEVEL_LIST_TABLE_LOADED,
    BLOCKFORMATLEVEL_LIST_TABLE_UNLOADED,

    BLOCKFORMATLEVEL_LIST_CHANGE_GROUP, 

    BLOCKFORMATLEVEL_SELECT_ROW,
    BLOCKFORMATLEVEL_ADD,
    BLOCKFORMATLEVEL_EDIT,
    BLOCKFORMATLEVEL_DELETE,
    BLOCKFORMATLEVEL_OPEN_WARNING,
    BLOCKFORMATLEVEL_CLOSE_WARNING,
    BLOCKFORMATLEVEL_DELETE_DISABLE,
    
    BLOCKFORMATLEVEL_EDIT_CONTAINER_LOADED,
    BLOCKFORMATLEVEL_EDIT_CONTAINER_UNLOADED,
    BLOCKFORMATLEVEL_EDIT_FORM_LOADED,
    BLOCKFORMATLEVEL_EDIT_FORM_UNLOADED,
    
    BLOCKFORMATLEVEL_EDIT_DATA_LOAD,
    BLOCKFORMATLEVEL_SET_GROUP_SELECT,

    BLOCKFORMATLEVEL_EDIT_CONTAINER_SUBMIT,
    BLOCKFORMATLEVEL_EDIT_CONTAINER_CANCEL
} from '../constants/actionTypeBlockFormatLevels';

const defaultState = {
    refreshList: false,
    danger: false,
    blockformatlevelid: 0,
    level: 0,
    block_start: '',
    block_nochild: '',
    block_child: '',
    block_between: '',
    block_end: '',
    element_start: '',
    element_nochild: '',
    element_between: '',
    element_end: '',
    createdate: '',
    modifydate: ''
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case BLOCKFORMATLEVEL_LIST_CONTAINER_LOADED:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockformatlevels: action.payload[0] ? action.payload[0].records : null,
                blockformats: action.payload[1] ? action.payload[1].records : null
            }
        case BLOCKFORMATLEVEL_LIST_TABLE_LOADED:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_LIST_CHANGE_GROUP:
            return {
                ...state,
                inProgress: false,
                errors: action.error ? action.payload.errors : null,
                blockformatlevels: action.payload[0] ? action.payload[0].records : null
            }
        case BLOCKFORMATLEVEL_SELECT_ROW:
            return {
                ...state,
                blockformatlevelid: action.id
            }
        case BLOCKFORMATLEVEL_ADD:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_EDIT:
            return {
                ...state,
                blockformatlevelid: action.id
            }
        case BLOCKFORMATLEVEL_DELETE:
            return {
                ...state,
                blockformatlevelid: null
            }
        case BLOCKFORMATLEVEL_DELETE_DISABLE:
            return {
                ...state,
                disableDelete: action.disabled
            }
        case BLOCKFORMATLEVEL_OPEN_WARNING:
            return {
                ...state,
                danger: true
            }
        case BLOCKFORMATLEVEL_CLOSE_WARNING:
            return {
                ...state,
                danger: false
            }
        case BLOCKFORMATLEVEL_EDIT_CONTAINER_LOADED:
        case BLOCKFORMATLEVEL_EDIT_DATA_LOAD:
            return {
                ...state,
                blockformatlevelid: action.payload[0] ? action.payload[0].blockformatlevelid : 0,
                blockformatid: action.payload[0] ? action.payload[0].blockformatid : 0,
                level: action.payload[0] ? action.payload[0].level : 0,
                block_start: action.payload[0] ? action.payload[0].block_start : '',
                block_nochild: action.payload[0] ? action.payload[0].block_nochild : '',
                block_child: action.payload[0] ? action.payload[0].block_child : '',
                block_between: action.payload[0] ? action.payload[0].block_between : '',
                block_end: action.payload[0] ? action.payload[0].block_end : '',
                element_start: action.payload[0] ? action.payload[0].element_start : '',
                element_nochild: action.payload[0] ? action.payload[0].element_nochild : '',
                element_between: action.payload[0] ? action.payload[0].element_between : '',
                element_end: action.payload[0] ? action.payload[0].element_end : '',
                createdate: action.payload[0] ? action.payload[0].createdate : '',
                modifydate: action.payload[0] ? action.payload[0].modifydate : ''
            }
        case BLOCKFORMATLEVEL_EDIT_FORM_LOADED:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_SET_GROUP_SELECT:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_EDIT_CONTAINER_SUBMIT:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_EDIT_CONTAINER_CANCEL:
            return {
                ...state
            }
        case BLOCKFORMATLEVEL_LIST_CONTAINER_UNLOADED:
        case BLOCKFORMATLEVEL_LIST_TABLE_UNLOADED:
        case BLOCKFORMATLEVEL_EDIT_CONTAINER_UNLOADED:
        case BLOCKFORMATLEVEL_EDIT_FORM_UNLOADED:
            return {};
        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/reducerBlockFormatLevels.js